export default "__VITE_ASSET__DRcewYQI__"